<template>
  <div class="pdfCheck">
    <!-- <canvas id="the-canvas"></canvas> -->
    <!-- <iframe :src="url" style="width: 100%; height: 100%"></iframe> -->
    <!-- <img :src="imgUrl" alt="" width="100%" height="auto">
    <canvas id="the-canvas" style="display: none"></canvas> -->
      <!-- <pdf
        ref="pdf"
        :src="url" 
         v-for="i in numPages" 
        :key="i"  
        :page="i" 
        ></pdf> -->
      <img class="absolute" src="../../../assets/download.png" @click="download" v-if="show"/>
      <div id="pdfShow">
        
      </div>
        
  </div>
</template>

<script>
import { enums } from "../../../enum";
 import Pdfh5 from "pdfh5";
 import "pdfh5/css/pdfh5.css";
// const PDF = require('pdfjs-dist');
// import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
// PDF.GlobalWorkerOptions.workerSrc = pdfjsWorker;
export default {
  name: 'pdfCheck',
  // components:{
  //   pdf
  // },
  data() {
    return {
      bpsdownload:"",
      show:true,
      type: "whitePaperUrl"
    };
  },
  created() {
    let query = this.$route.query;
    if ('type' in query) {
      this.type = query.type + 'PaperUrl';
      this.$router.title = (query.type == 'white') ? '白皮书' : "蓝皮书";
      document.title = (query.type == 'white') ? '白皮书' : "蓝皮书";
    }
  },
  mounted() {
    // this.init();
    // this.showPdf(this.$route.query.url)
    // this.getNumPages()
    this.getBPS();
    // ios 隐藏下载按钮 用户手动保存pdf即可
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if(isiOS)
    {
      this.show = false;
    }
  },
  methods: {
    init(address)
    {
      //实例化
      this.pdfh5 = new Pdfh5("#pdfShow", {
        pdfurl: address,
        maxZoom:1,
        zoomEnable:false
      });
      //监听完成事件
      // this.pdfh5.on("complete", function (status, msg, time) {
      //   console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
      // })
    },
    //白皮书地址
    getBPS(){
      this.$axios
        .post(enums.address+"/api/whitePaper/getUrl")
        .then(res => {
          this.bpsdownload = res.data.data.files[this.type];
          this.init(this.bpsdownload);
        });
    },
    download()
    {
      window.location.href = this.bpsdownload;
    },
  },
};
</script>
<style scoped>

.pdfCheck,#pdfShow
{
  width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
}
.absolute{
  position: fixed;
  bottom: 50%;
  right: 0.2rem;
  width: 1rem;
  height: 1rem;
  z-index: 1001;
}
</style>
<style>
#pdfShow img
{
  width: 100%!important;
}
#pdfShow .viewerContainer
{
  min-height: 100vh;
}
</style>





// WEBPACK FOOTER //
// src/modules/AtomicChain/pages/pdf.vue